module.exports = __webpack_public_path__ + "img/2014-dax.8236fe6c.jpg";